import type { StageBinding, StageCascadeWidget } from '../../../widgets';
import {
  BindingRow,
  ListEditor,
  OptionalBindingRow,
  Section,
  TextField,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Kaskade. Die Reihenfolge der Stufen ist die Reihenfolge auf dem Schirm und
 *  soll der Schaltfolge der Anlage entsprechen, darum das Umsortieren. */
export function StageCascadeEditor(
  { widget, plantId, missing, onChange }: WidgetEditorProps<StageCascadeWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Anzeige">
        <TextField
          label="Einheit der Auslastung"
          value={widget.loadUnit}
          placeholder="%"
          onChange={(next) => patch({ loadUnit: next })}
        />
      </Section>
      <Section title="Stufen">
        <ListEditor<StageBinding>
          label="Stufen"
          required
          missing={missing.has('stages')}
          items={widget.stages}
          addLabel="Stufe"
          emptyHint="Je Kessel beziehungsweise Verdichter eine Stufe."
          create={() => ({ label: `Stufe ${widget.stages.length + 1}`, statePoint: '' })}
          itemTitle={(s, i) => s.label || `Stufe ${i + 1}`}
          onChange={(next) => patch({ stages: next })}
          renderItem={(stage, patchStage) => (
            <>
              <TextField
                label="Beschriftung"
                value={stage.label}
                keepEmptyString
                required
                placeholder="Kessel 1"
                onChange={(next) => patchStage({ label: next ?? '' })}
              />
              <BindingRow
                label="Zustand"
                value={stage.statePoint}
                plantId={plantId}
                hint="Aus, Freigabe, Läuft. Bool oder Aufzählung."
                onChange={(next) => patchStage({ statePoint: next })}
              />
              <OptionalBindingRow
                label="Auslastung"
                value={stage.loadPoint}
                plantId={plantId}
                filter={{ valueType: 'number' }}
                onChange={(next) => patchStage({ loadPoint: next })}
              />
              <OptionalBindingRow
                label="Laufzeit"
                value={stage.runtimePoint}
                plantId={plantId}
                filter={{ valueType: 'number' }}
                onChange={(next) => patchStage({ runtimePoint: next })}
              />
            </>
          )}
        />
      </Section>
    </>
  );
}
